import { allowedBrands } from '@/configuration/sources/smartform/samsungPay.yml'
import { getSamsungPayFormattedAmount } from '../../../common/util/currencyFormatter'
import { CoBrands, SubBrands } from '@/configuration/sources/Brands.yml'

/**
 * File dedicated to build SamsungPay data structures needed by the client
 * https://developer.samsung.com/pay/web/api-reference.html
 */

export function getAllowedBrands(
  dnaBrands,
  dnaMetadataCards,
  disableVisaOnWallet
) {
  const formatBrand = brand => {
    // LATAM brand variation to generic brand
    let formattedBrand = CoBrands.brands[brand] ?? brand
    // Specific changes of sub-brands must adapt to samsungPay supported brands
    formattedBrand = SubBrands[formattedBrand] ?? formattedBrand
    return formattedBrand
  }
  // If DNA has specific card brands for Samsung Pay, use those
  if (dnaMetadataCards?.length) {
    const transformedMetadataBrands = dnaMetadataCards.map(formatBrand)
    let samsungAllowedBrands = transformedMetadataBrands
      .map(brand => allowedBrands[brand])
      .filter(b => !!b)
    if (disableVisaOnWallet)
      samsungAllowedBrands = samsungAllowedBrands.filter(
        brand => brand !== 'visa'
      )
    return Array.from(new Set(samsungAllowedBrands))
  }

  if (!dnaBrands) return []
  const transformedDnaBrands = dnaBrands.map(formatBrand)
  let samsungAllowedBrands = transformedDnaBrands
    .map(brand => allowedBrands[brand])
    .filter(b => !!b)

  if (disableVisaOnWallet)
    samsungAllowedBrands = samsungAllowedBrands.filter(
      brand => brand !== 'visa'
    )
  return Array.from(new Set(samsungAllowedBrands))
}
export function getSamsungPaymentMethods({
  samsungPayServiceId,
  dnaBrands,
  dnaMetadataCards,
  disableVisaOnWallet
}) {
  return {
    version: '2',
    serviceId: samsungPayServiceId,
    protocol: 'PROTOCOL_3DS',
    allowedBrands: getAllowedBrands(
      dnaBrands,
      dnaMetadataCards,
      disableVisaOnWallet
    ),
    merchantChoiceBrands: {
      type: 'PREFERENCE',
      brands: ['cb']
    }
  }
}

export function getSamungTransactionDetails({
  orderNumber,
  merchantName,
  merchantUrl,
  merchantId,
  countryCode,
  amount,
  currency
}) {
  return {
    orderNumber,
    merchant: {
      name: merchantName,
      url: merchantUrl,
      id: merchantId,
      countryCode
    },
    amount: {
      option: 'FORMAT_TOTAL_ESTIMATED_AMOUNT',
      currency: currency,
      total: getSamsungPayFormattedAmount(amount, currency)
    }
  }
}
